import { Component, ErrorInfo, ReactNode } from 'react';
import { getAppInsights } from './appInsights';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const appInsights = getAppInsights();
    
    if (appInsights) {
      appInsights.trackException({
        error: error,
        properties: {
          componentStack: errorInfo.componentStack,
          ...error
        }
      });
    }
    
    console.error('Error caught by error boundary:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <h1>Sorry.. there was an error</h1>
          {this.state.error && (
            <div>
              <p>{this.state.error.message}</p>
              <p>Please try refreshing the page or contact support if the problem persists.</p>
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
} 